import React from "react";
import { Button, Card } from "flowbite-react";
import successIcon from "../../assets/icons/success.png";

export default function OrderConfirmationBox(props) {
  const {
    languages,
    membership = "Traveller Membership",
    memberServiceLink = "#",
    onClick = () => {},
  } = props;
  return (
    <div className="flex flex-col items-center justify-center w-[864px] py-8 px-24 bg-white xs:px-4 xs:w-auto">
      <div>
        {/* <h3 className="text-sm font-medium font-inter tracking-wider uppercase text-center text-[#557B97] mb-8 xs:text-xs">
                    Your {membership}
                </h3> */}
        <div className="flex justify-center">
          <img
            src={successIcon}
            alt="success-register-accorplus"
            className="w-[96px] h-[96px]"
          />
        </div>
        <p className="text-xl font-bold font-inter text-center mt-8">
          {languages && languages.orderConfirmed
            ? languages.orderConfirmed
            : "Your subscription is confirmed"}
        </p>
      </div>
      <p className="font-medium text-lg text-[#221B1A] text-center font-montserrat my-8">
        {/* {languages && languages.registeredOrderDescription1 ? languages.registeredOrderDescription1 : 'Your subscription has been registered.'} */}
        {/* <br /> */}
        <span>
          {languages && languages.registeredOrderDescription2
            ? languages.registeredOrderDescription2
            : "Next Steps"}
        </span>
      </p>

      <div className="flex flex-col justify-center items-center">
        <ul className="list-disc confirmation-list-disc text-base font-montserrat text-[#252339] px-4 text-center">
          <li className="list-none">
            {languages && languages.exploreMessageListConfirmation
              ? languages.exploreMessageListConfirmation
              : "In a few minutes you will receive a confirmation email of your order."}
          </li>
          <li className="list-none">
            {languages && languages.exploreMessageListConfirmation1
              ? languages.exploreMessageListConfirmation1
              : "Activate your membership now or follow the steps in the email."}
          </li>
          {/* <li>Follow the steps in the email to activate your membership.</li>
                    <li>Remember to also check your spam Inbox. If you don&apos;t receive an email, please contact <a href={memberServiceLink} className='text-[#18A09F] underline'>Member Services</a>.</li> */}
        </ul>

        {/* <div className="mt-8 xs:mt-20 w-full flex justify-center">
                    <Button size="lg" outline onClick={onClick} className="xs:mt-20 xs:w-full">
                        <span className='px-16 xs:px-24 upperacase font-inter'>CLOSE</span>
                    </Button>
                </div> */}
        <div className="mt-4 w-full flex justify-center">
          {/* <button onClick={onClick} className="mt-4 p-2 btn-outline-blue rounded-sm shadow-md  xs:w-full">
                        
                    </button> */}
          <a
            href={
              languages.getStartedCTALink
                ? languages.getStartedCTALink
                : "https://www.accorplus.com/get-started-confirmation/"
            }
            target="_blank"
            className="mt-4 p-2 btn-outline-blue rounded-sm shadow-md  xs:w-full text-center"
          >
            <span className="px-16 xs:px-8 uppercase font-inter font-medium text-lg">
              {languages && languages.getStartedCTA
                ? languages.getStartedCTA
                : "Get started"}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
